module.exports = __webpack_public_path__ + "57f10d29fa648b9c3d241259258934e6.png";